export const DO_LOGIN = "DO_LOGIN";
export const DO_LOGOUT = "DO_LOGOUT";
export const DO_LOCKED = "DO_LOCKED";
export const DO_UNLOCKED = "DO_UNLOCKED";
export const GET_PROFILE = "GET_PROFILE";
export const GET_BALANCE = "GET_BALANCE";
export const GET_BALANCE_USER = "GET_BALANCE_USER";